import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=35669532&scoped=true&"
import script from "./tables.vue?vue&type=script&lang=js&"
export * from "./tables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35669532",
  null
  
)

export default component.exports